const projectId = 'md-live-prod'
const functionRegion = 'europe-west2'

export default {
  projectId,
  functionRegion,
  apiKey: 'AIzaSyCFpUZCH4PiTaRAFq4EKAUKL8X2FDQr_LI',
  authDomain: `${projectId}.firebaseapp.com`,
  storageBucket: `${projectId}.appspot.com`,
  functionsUrl: `https://${functionRegion}-${projectId}.cloudfunctions.net`,
  hostingUrl: `https://${projectId}.web.app`,
}
